import React from "react";
import { Button, Chip, Stack, TextField } from "@mui/material";
import { types } from "../../utils/static";
const Fiterbar = ({ filterChange, searchChnage, selectedFilter }) => {

  const handleBlur  = ()=>{
    filterChange('all')

  }


  return (
    <div>
      <Stack spacing={2}>
        <TextField
          onClick={handleBlur}
          onChange={searchChnage}
          size="small"
          label="search here"
          fullWidth
        />
        <div style={{ overflowX: "auto" }}>
          <Stack direction="row" spacing={1}>
            {['today','last 3 days',...types].map((item, index) => (
              <Chip
                onClick={() => filterChange(item)}
                color={selectedFilter === item ? "success" : "default"}
                key={index}
                label={item}
           
              />
            ))}
          </Stack>
        </div>
      </Stack>
    </div>
  );
};

export default Fiterbar;
